import React from "react"
import { Link } from "react-router-dom"
import UserProfile from "./UserProfile"
import { IoIosArrowBack } from "react-icons/io"
import { FiSearch } from "react-icons/fi"
import { MdClose } from "react-icons/md"

const ComponentHeader = (props: any) => {
    //The search term is owned by the page, it drives both the fetch and the result summary
    const { layoutId, layoutCode, layoutName, device, searchTerm, onSearchChange } = props

    return (<>
        <div className="header">
            <div className="header-inner">
                <div className="main-header flex items-center p-[15px]">
                    <div className="header-left">
                    </div>
                    <UserProfile />
                </div>
                <div className="haderVarient2 items-center flex justify-between p-[15px] ">
                    <div className="pagename-n-input flex items-center ">
                        <Link to={`/layout/${layoutId}`}><IoIosArrowBack /></Link>

                        <div className="pagename-sec">
                            <h2 className='font-bold'>{layoutName || "Layout"}</h2>
                            <p className='text-xs p-subname'>{device} | {layoutCode}</p>
                        </div>
                    </div>

                    {/* Sits in the actions slot, the same place the layout page keeps its buttons */}
                    <div className="header-search flex items-center justify-end">
                        <div className="form-field">
                            <div className="input-field ">
                                <input
                                    value={searchTerm}
                                    onChange={(e) => onSearchChange(e.target.value)}
                                    type="text"
                                    className="if-search-left"
                                    placeholder="Search component.." />
                                <div className="search-icon-left flex justify-around items-center">
                                    <FiSearch size={16} />
                                </div>
                                {searchTerm ?
                                    <div
                                        onClick={() => onSearchChange("")}
                                        title="Clear search"
                                        className="search-clear flex items-center cursor-pointer">
                                        <MdClose size={16} />
                                    </div>
                                    : null}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>)


}

export default ComponentHeader
